import React from "react";
import './Marquee.css'

const MarqueeHeader = () => {


    const marqueeContent = [
        'LATEST NEWS UPDATE ON PAYROLL', 'EARLY PAYROLL ON 6/9/2023', 'A NEW UPDATE ADDED', 'EARLY PAYROLL ON NEXT MONDAY'
    ]

    return (
        <div className="mq-wholediv">
            <marquee className="mq-class" direction="left">
                <div className="mq-singlediv">
                    {
                        marqueeContent.map((item, i) => {
                            return (
                                <div className="mq-items">
                                    <li className="mq-bullet"></li>
                                    <span key={i} className="mq-span">{item}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </marquee>
        </div>
    )
}

export default MarqueeHeader;